module.exports = {"pages":{"test":""},"shared":{"test":""}}